import React, { useState, useEffect, useRef, useCallback } from 'react';

function CustomSingleResourcePage(props) {  
    return (
        <div>
            Development In Progress...
        </div>
    );
}

export default CustomSingleResourcePage;
